import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-sortable-handle]",
      // Дерево (рубрики изделий) выводится одним списком, но порядок живёт внутри
      // уровня: строку можно двигать только между соседями по родителю. Иначе
      // ребёнок «встаёт» выше родителя на экране, а после перезагрузки
      // возвращается — дерево-то строится по родителю, а не по позиции.
      onMove: (event) => {
        const from = event.dragged?.dataset?.parent
        const to = event.related?.dataset?.parent
        return from === undefined || to === undefined || from === to
      },
      onEnd: () => this.save()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  save() {
    const ids = Array.from(this.element.querySelectorAll(":scope > [data-sortable-item]"))
      .map(el => el.dataset.id)
    const token = document.querySelector("meta[name='csrf-token']")?.content
    fetch(this.urlValue, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
      body: JSON.stringify({ ids })
    })
  }
}
